import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {  IUserSettingsAddPathBody } from '../../../../interface/interfaces';

interface IInitialState {
    allPaths: IUserSettingsAddPathBody[];
}

const initialState: IInitialState = {
    allPaths: [],
};

const allPathsSlice = createSlice({
    name: 'allPaths',
    initialState,
    reducers: {
        saveAllPaths: (state: IInitialState, action: PayloadAction<IUserSettingsAddPathBody[]>) => {
            state.allPaths = action.payload;
        },
        removeAllPaths: (state: IInitialState) => {
            state.allPaths = [];
        },
        updateAllPaths: (state: IInitialState, action: PayloadAction<IUserSettingsAddPathBody>) => {
            const index = state.allPaths.findIndex(path => 
                path.user_id === action.payload.user_id &&
                path.project_id === action.payload.project_id &&
                path.device_id === action.payload.device_id &&
                path.tool === action.payload.tool
            );
            if (index !== -1) {
                state.allPaths[index] = action.payload;
            }
        },
        addToAllPaths: (state: IInitialState, action: PayloadAction<IUserSettingsAddPathBody>) => {
            const exists = state.allPaths.some(path => 
                path.user_id === action.payload.user_id &&
                path.project_id === action.payload.project_id &&
                path.device_id === action.payload.device_id &&
                path.tool === action.payload.tool
            );
            if (!exists) {
                state.allPaths.push(action.payload);
            } else {
                allPathsSlice.caseReducers.updateAllPaths(state, action);
            }
        },
    },
});

export default allPathsSlice.reducer;
export const { saveAllPaths, removeAllPaths, updateAllPaths, addToAllPaths } = allPathsSlice.actions;
